import {
  InlineBanner,
  Link as DesignSystemLink,
  Text,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import React from 'react'
import { useHasOutdatedTaxCategory } from '../hook/useHasOutdatedTaxCategory'
import { LineItem } from '../../../../../models/line-item'

const WARNING_CONTEXT =
  'Sale Line Item Expanded > Fulfillment > Outdated Tax Category'

interface OutdatedTaxCategoryWarningProps {
  lineItem: LineItem
}

export const OutdatedTaxCategoryWarningLegacy: React.FC<OutdatedTaxCategoryWarningProps> = ({
  lineItem,
}) => {
  const t = useT()
  const isOutdated = useHasOutdatedTaxCategory(
    lineItem?.id || lineItem?.localId
  )

  if (!isOutdated) {
    return null
  }

  const productId = lineItem.product?.variant_parent_id || lineItem.product?.id
  const message = t('Outdated tax category may affect tax calculations.', {
    _key: 'sale.line-item-expanded.fulfilment.outdated-tax-category',
    _context: WARNING_CONTEXT,
  })
  const linkText = t('Update category', {
    _key: 'sale.line-item-expanded.fulfilment.update-category-link',
    _context: WARNING_CONTEXT,
  })

  return (
    <InlineBanner
      variant="negative"
      icon="warning"
      data-testid="outdated-tax-category-warning"
    >
      <Text type="label">
        {message}{' '}
        <DesignSystemLink href={`/product/${productId}/update`}>
          {linkText}
        </DesignSystemLink>
      </Text>
    </InlineBanner>
  )
}
